import React from 'react';
import PhoneNumberField from './PhoneNumberField';

export default function StepDetails({
  isAuthenticated,
  patientName,
  patientEmail,
  mode,
  setMode,
  email,
  setEmail,
  phone,
  setPhone,
  dob,
  setDob,
  sex,
  setSex,
  password,
  setPassword,
  newPassword,
  setNewPassword,
  onLogin,
  onLogout,
  authLoading,
  authError,
}) {
  const normalizedSex = String(sex || '').toLowerCase();
  const showProfileFields = mode === 'new' || isAuthenticated;

  return (
    <div className="lcw-card">
      <div className="lcw-card-body">
        <div className="lcw-section-title">Contact</div>

        <div className="lcw-tabs lcw-stack-sm">
          <button type="button" className={`lcw-tab ${mode === 'new' ? 'active' : ''}`} onClick={() => setMode('new')}>
            New patient
          </button>
          <button type="button" className={`lcw-tab ${mode === 'account' ? 'active' : ''}`} onClick={() => setMode('account')}>
            I have an account
          </button>
        </div>

        {mode === 'blocked' && !isAuthenticated && (
          <div className="lcw-error" role="alert">{authError}</div>
        )}

        {mode === 'account' && !isAuthenticated && (
          <form onSubmit={onLogin}>
            <p className="lcw-helper">Log in and we'll fill in your details and saved payment method.</p>
            <div className="lcw-input-group">
              <label className="lcw-label">Email</label>
              <input className="lcw-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" autoComplete="email" />
            </div>
            <div className="lcw-input-group">
              <label className="lcw-label">Password</label>
              <input className="lcw-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" />
            </div>
            {authError && <div className="lcw-error">{authError}</div>}
            <button type="submit" className="lcw-btn-outline lcw-stack-xs" disabled={authLoading}>
              {authLoading ? 'Signing in...' : 'Log in'}
            </button>
          </form>
        )}

        {isAuthenticated && (
          <div className="lcw-signed-in">
            <div className="lcw-signed-in-info">
              <strong>Signed in as {patientName}</strong>
              <span>{patientEmail}</span>
            </div>
            <button type="button" className="lcw-logout" onClick={onLogout}>Log out</button>
          </div>
        )}

        {isAuthenticated ? (
          <p className="lcw-prefill-note">Pulled from your profile. Edit anything that's changed.</p>
        ) : (
          mode === 'new' && <p className="lcw-helper">Create an account so your order, results, and saved cards stay connected.</p>
        )}

        {showProfileFields && (
          <>
            <div className="lcw-input-group">
              <label className="lcw-label">Email</label>
              <input className="lcw-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" autoComplete="email" />
            </div>
            <PhoneNumberField value={phone} onChange={setPhone} />
            {!isAuthenticated && (
              <div className="lcw-input-group">
                <label className="lcw-label">Create password</label>
                <input
                  className="lcw-input"
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  autoComplete="new-password"
                />
                <span className="lcw-field-note">Used for your patient portal and future saved payment methods.</span>
              </div>
            )}
          </>
        )}
      </div>

      <div className="lcw-card-divider" />
      <div className="lcw-card-body">
        <div className="lcw-section-title">Patient details</div>
        <p className="lcw-section-sub">A licensed provider uses these details while processing your lab order.</p>

        <div className="lcw-row-2">
          <div className="lcw-input-group">
            <label className="lcw-label">Date of birth</label>
            <input className="lcw-input" type="date" value={dob} onChange={e => setDob(e.target.value)} />
          </div>
          <div className="lcw-input-group">
            <label className="lcw-label">Sex at birth</label>
            <select className="lcw-input" value={normalizedSex} onChange={e => setSex(e.target.value)}>
              <option value="">Select...</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
